import React, { useState } from 'react';
import { MapPin } from 'lucide-react';
import { useLocationScope } from '../context/LocationContext';

function HometownPrompt() {
  const { enabledMetros, hometownMetroId, setHometown, needsHometown } = useLocationScope();
  const [selected, setSelected] = useState(hometownMetroId || 'chicago');
  const [dismissed, setDismissed] = useState(false);

  if (!needsHometown || dismissed) return null;

  const handleSave = async () => {
    await setHometown(selected);
    setDismissed(true);
  };

  return (
    <div className="fixed inset-0 z-[2000] bg-black/70 flex items-center justify-center p-4">
      <div className="bg-dive-dark border border-dive-gray rounded-2xl p-6 max-w-md w-full">
        <div className="w-12 h-12 rounded-xl bg-dive-neon/20 flex items-center justify-center mb-4">
          <MapPin className="w-6 h-6 text-dive-neon" />
        </div>
        <h2 className="text-white text-xl font-display mb-2">Where do you drink?</h2>
        <p className="text-gray-400 text-sm mb-4">
          Pick your hometown so the map and list open on your bars. You can change this anytime in Settings.
        </p>
        <select
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="w-full bg-dive-darker border border-dive-gray rounded-lg px-3 py-3 text-white mb-4"
        >
          {enabledMetros.map((metro) => (
            <option key={metro.id} value={metro.id}>
              {metro.name}, {metro.state}
            </option>
          ))}
        </select>
        <button onClick={handleSave} className="btn-primary w-full">
          Set hometown
        </button>
      </div>
    </div>
  );
}

export default HometownPrompt;
